import script from "./MapaEnderecoAtendimento.vue?vue&type=script&setup=true&lang=js"
export * from "./MapaEnderecoAtendimento.vue?vue&type=script&setup=true&lang=js"

import "./MapaEnderecoAtendimento.vue?vue&type=style&index=0&id=1c0dd60f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c0dd60f"]])

export default __exports__